<script lang="ts">
  import Icon from './Icon.svelte'

  export let icon: string | undefined = undefined
  export let open = false
  export let value: string

  function handleKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      open = !open
    }
  }
</script>

<details class="group" {open}>
  <summary
    role="tree"
    tabindex="0"
    class="group-title"
    on:keydown|preventDefault={handleKeydown}
    on:click|preventDefault={() => (open = !open)}
  >
    {#if icon}
      <Icon {icon} />
    {/if}
    {value}
    <div class="arrow">
      <Icon icon="ph-caret-down" size={1.1} />
    </div>
  </summary>
  <slot />
</details>

<style lang="scss">
  summary::-webkit-details-marker {
    display: none;
  }

  .group[open] {
    padding-bottom: 8px;

    .group-title {
      color: inherit;
      font-weight: 500;

      .arrow {
        transform: rotate(180deg);
      }
    }
  }

  .group-title {
    display: flex;
    align-items: center;
    gap: 0.25em;
    padding: 10px 12px;
    color: var(--color-on-surface);
    transition: background-color 0.125s;
    cursor: pointer;

    .arrow {
      margin-left: auto;
      transition: transform 0.25s;
    }
  }

  .group-title:hover {
    color: inherit;
    background: var(--color-on-surface-hover);
  }
</style>
